export default __webpack_public_path__ + "static/media/NoirPro-Heavy.d8a492a7.woff";